import React, { useState, useEffect } from 'react';
import './Career.css';
import SummaryApi from '../../components/common/index'; 
import { Helmet } from "react-helmet-async";


const Career = () => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedJob, setSelectedJob] = useState(null); 
    const [isExperienced, setIsExperienced] = useState(false); 
    const [submitting, setSubmitting] = useState(false);

    const fetchJobs = async () => {
        try {
            setLoading(true);
            const response = await fetch(SummaryApi.getCareers.url);
            const result = await response.json();
            const rawData = Array.isArray(result) ? result : result.data;

            if (rawData) {
                const activeJobs = rawData.filter(job => Number(job.is_closed) !== 1);
                setJobs(activeJobs);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchJobs();
    }, []);

    // FIX: Synced 'mobile_number' name with the form input
    const validateForm = (formData) => {
        const email = formData.get("email");
        const mobile = formData.get("mobile_number"); 
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Please enter a valid email address.");
            return false;
        }

        const mobileRegex = /^[0-9]{10}$/;
        if (!mobile || !mobileRegex.test(mobile)) {
            alert("Please enter a valid 10-digit mobile number.");
            return false;
        }
        return true;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const formElement = e.target;
        const formData = new FormData(formElement);
        
        if (!validateForm(formData)) return;

        setSubmitting(true);

        const jobIdToSend = selectedJob.id || selectedJob.job_id || selectedJob.career_id;
        formData.append("job_id", jobIdToSend);

        try {
            const response = await fetch(SummaryApi.createApplicant.url, {
                method: "POST",
                body: formData,
            });

            const responseText = await response.text();
            try {
                const result = JSON.parse(responseText);
                if (result.status === "success" || result.status === true) {
                    alert("Application submitted successfully!");
                    
                    // RESET AND GO BACK
                    formElement.reset();
                    setIsExperienced(false);
                    setSelectedJob(null);
                    window.scrollTo(0, 0);
                } else {
                    alert(result.message || "Submission failed.");
                }
            } catch (jsonErr) {
                console.error("Server Error Response:", responseText);
                alert("Server Error: Received invalid response from server.");
            }
        } catch (error) {
            alert("Network Error: " + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    const JobCard = ({ job, onApply }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const textLimit = 120;
        const requirements = job.requirements || "";
        const isLong = requirements.length > textLimit;

        return (
            <div className="cr-job-card">
                {/* Career Page */}
<Helmet>
<title>Careers at Oakya IT Services | Join Our Team & Grow Your Career</title>
<meta
name="description"
content="Explore exciting career opportunities at Oakya IT Services. Join our team and build your future in technology, marketing, and innovation."
/>
<meta
name="keywords"
content="careers Oakya IT Services, Vijayawada IT jobs, Andhra Pradesh jobs, digital marketing jobs Vijayawada, SEO jobs India, web development careers, fresher IT jobs, Oakya hiring"
/>
<meta name="author" content="Oakya IT Services" />
<meta name="robots" content="index, follow" />
<meta name="publisher" content="Oakya IT Services" />
<link
rel="canonical"
href="https://oakyaitservices.com/career"
/>

{/* Open Graph Tags */}
<meta
property="og:title"
content="Careers at Oakya IT Services | Join Our Team & Grow Your Career"
/>
<meta
property="og:description"
content="Join Oakya IT Services in Vijayawada. Explore careers in IT, SEO, digital marketing, and development."
/>
<meta
property="og:type"
content="website"
/>
<meta
property="og:url"
content="https://oakyaitservices.com/career"
/>
</Helmet>
                <div className="cr-card-header">
                    <span className="cr-badge">{job.job_subtitle || 'Full Time'}</span>
                    <h3 title={job.job_title}>{job.job_title}</h3>
                </div>
                <div className="cr-card-body">
                    <div className="cr-info-item">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
                        <span><strong>Skills:</strong> {job.key_skills}</span>
                    </div>
                    <div className="cr-info-item">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                        <span>
                            <strong>Requirements:</strong> {isExpanded ? requirements : `${requirements.substring(0, textLimit)}...`}
                            {isLong && (
                                <button className="cr-view-more" onClick={() => setIsExpanded(!isExpanded)}>
                                    {isExpanded ? " Show Less" : " View More"}
                                </button>
                            )}
                        </span>
                    </div>
                    <div className="cr-info-item">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                        <span><strong>Qualification:</strong> {job.qualification}</span>
                    </div>
                </div>
                <div className="cr-card-footer">
                    <div className="cr-openings">
                        <strong>{job.number_of_positions}</strong> Positions Open
                    </div>
                    <button className="cr-apply-btn" onClick={() => onApply(job)}>Apply Now</button>
                </div>
            </div>
        );
    };

    return (
        <div className="cr-page-wrapper">
            <header className="cr-hero">
                <div className="cr-hero-content">
                    <h1>Shape the Future with Us</h1>
                    <p>Be part of a team that values innovation, creativity, and impact.</p>
                </div>
            </header>
            <main className="cr-container">
                <div className="cr-section-header">
                    <h2>Current Openings</h2>
                    <div className="cr-divider"></div>
                </div>
                {loading ? (
                    <div className="cr-loading"><div className="cr-spinner"></div><p>Loading Opportunities...</p></div>
                ) : jobs.length === 0 ? (
                    <div className="cr-empty">No positions currently open. Check back later!</div>
                ) : (
                    <div className="cr-grid">
                        {jobs.map((job, index) => (
                            <JobCard key={job.id || index} job={job} onApply={setSelectedJob} />
                        ))}
                    </div>
                )}
            </main>

            {selectedJob && (
                <div className="cr-modal-overlay">
                    <div className="cr-modal">
                        <div className="cr-modal-header">
                            <div>
                                <h2>Application Form</h2>
                                <p>Applying for: <span>{selectedJob.job_title}</span></p>
                            </div>
                            <button className="cr-close" onClick={() => setSelectedJob(null)}>&times;</button>
                        </div>
                        <form className="cr-form" onSubmit={handleFormSubmit}>
                            <div className="cr-form-grid">
                                <div className="cr-input-group">
                                    <label>Full Name *</label>
                                    <input type="text" name="full_name" required placeholder="John Doe" />
                                </div>
                                <div className="cr-input-group">
                                    <label>Email Address *</label>
                                    <input type="email" name="email" required placeholder="john@example.com" />
                                </div>
                                <div className="cr-input-group">
                                    <label>Mobile Number *</label>
                                    <input
                                        type="tel"
                                        name="mobile_number"
                                        placeholder="Mobile Number"
                                        required
                                        inputMode="numeric"
                                        maxLength="10"
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/\D/g, "");
                                        }}
                                    />
                                </div>
                                <div className="cr-input-group">
                                    <label>Current City *</label>
                                    <select name="city" required>
                                        <option value="">Select City</option>
                                        <option value="Hyderabad">Hyderabad</option>
                                        <option value="Vijayawada">Vijayawada</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                            <div className="cr-input-group">
                                <label>Resume (PDF) *</label>
                                <input type="file" name="resume" accept=".pdf" required />
                            </div>
                            <div className="cr-input-group">
                                <label>Experience Level *</label>
                                <div className="cr-radio-group">
                                    <label className="cr-radio">
                                        <input type="radio" name="status" value="fresher" checked={!isExperienced} onChange={() => setIsExperienced(false)} />
                                        <span>Fresher</span>
                                    </label>
                                    <label className="cr-radio">
                                        <input type="radio" name="status" value="experienced" checked={isExperienced} onChange={() => setIsExperienced(true)} />
                                        <span>Experienced</span>
                                    </label>
                                </div>
                            </div>

                            {isExperienced && (
                                <div className="cr-exp-section">
                                    <div className="cr-form-grid">
                                        <div className="cr-input-group">
                                            <label>Current Company</label>
                                            <input type="text" name="current_working_company" required />
                                        </div>
                                        <div className="cr-input-group">
                                            <label>Designation</label>
                                            <input type="text" name="current_designation" required />
                                        </div>
                                        <div className="cr-input-group">
                                            <label>Current CTC (LPA)</label>
                                            <input type="text" name="current_ctc" required />
                                        </div>
                                        <div className="cr-input-group">
                                            <label>Expected CTC (LPA)</label>
                                            <input type="text" name="expected_ctc" required />
                                        </div>
                                        <div className="cr-input-group">
                                            <label>Experience (Years)</label>
                                            <select name="experience" required>
                                                {[...Array(15)].map((_, i) => (
                                                    <option key={i} value={i + 1}>{i + 1} Year{i > 0 ? 's' : ''}</option>
                                                ))}
                                                <option value="15+">15+ Years</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button type="submit" className="cr-submit-btn" disabled={submitting}>
                                {submitting ? "Processing..." : "Submit Application"}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Career;